"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentsPerYear = exports.getPaymentPeriodFactor = exports.PaymentPeriods = exports.PaymentPeriod = void 0;
var PaymentPeriod;
(function (PaymentPeriod) {
    PaymentPeriod["Monthly"] = "Monthly";
    PaymentPeriod["Quarterly"] = "Quarterly";
    PaymentPeriod["SemiAnnually"] = "SemiAnnually";
    PaymentPeriod["Annually"] = "Annually";
})(PaymentPeriod = exports.PaymentPeriod || (exports.PaymentPeriod = {}));
exports.PaymentPeriods = Object.values(PaymentPeriod);
const getPaymentPeriodFactor = (paymentPeriod) => {
    switch (paymentPeriod) {
        case PaymentPeriod.Quarterly:
            return 3;
        case PaymentPeriod.SemiAnnually:
            return 6;
        case PaymentPeriod.Annually:
            return 11;
        case PaymentPeriod.Monthly:
        default:
            return 1;
    }
};
exports.getPaymentPeriodFactor = getPaymentPeriodFactor;
const getPaymentsPerYear = (paymentPeriod) => {
    switch (paymentPeriod) {
        case PaymentPeriod.Quarterly:
            return 4;
        case PaymentPeriod.SemiAnnually:
            return 2;
        case PaymentPeriod.Annually:
            return 1;
        case PaymentPeriod.Monthly:
        default:
            return 12;
    }
};
exports.getPaymentsPerYear = getPaymentsPerYear;
//# sourceMappingURL=payment-period.js.map